var _a;
export var Canonical = {
    USER_LOGIN: 'https://www.ciceksepeti.com/uye-girisi',
    NEW_MEMBERSHIP: 'https://www.ciceksepeti.com/yeni-uyelik'
};
export var Pathname = {
    USER_LOGIN: '/uye-girisi',
    NEW_MEMBERSHIP: '/yeni-uyelik',
    GUEST_ORDER_INQUIRY_FORM: '/siparis-takip',
    CHECKOUT_REGISTRATION: '/kullanici-girisi',
    CART: '/sepetim',
    ORDER_REVIEW: '/siparis-degerlendir',
    POST_CHECKOUT: '/tesekkurler'
};
export var MetaConfig = (_a = {},
    _a[Pathname.USER_LOGIN] = {
        title: 'Çiçeksepeti Üye Giriş Sayfası',
        description: "Çiçeksepeti'ne üye girişi yapıp online alışverişe hemen başlayın! Çiçeksepeti üye giriş sayfası için tıklayabilirsiniz.",
        robots: 'index, follow',
        canonical: Canonical.USER_LOGIN
    },
    _a[Pathname.NEW_MEMBERSHIP] = {
        title: 'Çiçeksepeti Üye Ol - Çiçeksepeti Yeni Üyelik',
        description: 'Çiçeksepeti ile alışverişe hemen başlamak, kuponlardan faydalanmak ve daha birçok avantaj için yeni üyelik sayfasını ziyaret edebilirsiniz.',
        robots: 'index, follow',
        canonical: Canonical.NEW_MEMBERSHIP
    },
    _a[Pathname.GUEST_ORDER_INQUIRY_FORM] = {
        robots: 'index, follow'
    },
    _a);
